import { render } from "./BaseNavbarLink.vue?vue&type=template&id=8c5a11a0"
import script from "./BaseNavbarLink.vue?vue&type=script&lang=js"
export * from "./BaseNavbarLink.vue?vue&type=script&lang=js"

import "./BaseNavbarLink.vue?vue&type=style&index=0&id=8c5a11a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__